// extracted by mini-css-extract-plugin
export default {"transaction":"TransactionHistory_transaction__Hjrz4"};